import React from 'react';
import { CmsSsrComponentProps, ISize } from '@/types/cms';
import Container from './Container';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

// 字体大小映射配置
const FONT_SIZE_CLASSES = {
  [ISize.small]: 'enki-heading-sm-strong',
  [ISize.middle]: 'enki-heading-xl-strong',
  [ISize.large]: 'enki-heading-3xl-strong'
} as const;

const Title: React.FC<CmsSsrComponentProps> = props => {
  const { componentKey, componentInstanceKey, properties, top } = props;

  return (
    <Container
      componentKey={componentKey}
      componentInstanceKey={componentInstanceKey}
      properties={properties}
      className="px-3 py-2.5"
      top={top}>
      <div
        style={{
          color: properties?.color,
          textAlign: properties?.align as any
        }}
        className={twMerge(
          classNames(
            'tracking-[0.38px] leading-[125%] font-semibold break-words',
            FONT_SIZE_CLASSES[properties.font_size as ISize]
          )
        )}>
        {properties?.text}
      </div>
    </Container>
  );
};

export default Title;
